export const NAME = "activeModal";
